import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <img src="logo.png" alt="Neha Packers & Movers Logo" className="logo-image" />
        </Link>

        <a href="tel:9625581855" className="navbar-phone-mobile">
          <i className="fas fa-phone-alt"></i> 9625581855
        </a>

        <button
          className={`mobile-menu-icon ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {isMobileMenuOpen && (
          <div className="navbar-overlay" onClick={closeMenu}></div>
        )}

        <div className={`navbar-menu-wrapper ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
          <ul className="navbar-links">
            <li className="navbar-item">
              <Link to="/" className="navbar-link" onClick={closeMenu}>Home</Link>
            </li>
            <li className="navbar-item">
              <Link to="/about" className="navbar-link" onClick={closeMenu}>About Us</Link>
            </li>
            <li className="navbar-item">
              <Link to="/services" className="navbar-link" onClick={closeMenu}>Services</Link>
            </li>
            <li className="navbar-item">
              <Link to="/gallery" className="navbar-link" onClick={closeMenu}>Gallery</Link>
            </li>
            <li className="navbar-item">
              <Link to="/service-locations" className="navbar-link" onClick={closeMenu}>Locations</Link>
            </li>
            <li className="navbar-item">
              <Link to="/contact" className="navbar-link" onClick={closeMenu}>Contact Us</Link>
            </li>
          </ul>

          <div className="navbar-actions">
            <a href="tel:9625581855" className="navbar-phone">
              <i className="fas fa-phone-alt"></i> 9625581855
            </a>
            <Link to="/quote" className="navbar-cta-btn" onClick={closeMenu}>
              Get a Quote
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
